import api from './api'

/**
 * ArtDent 261007 — "New from partners" on the admin and coordinator
 * dashboards: the patients a partner registered themselves, newest first.
 * `opened_by` is null on an opened row for the patients registered before the
 * panel existed — they start opened, by nobody in particular.
 */
export interface AffiliatorIntakeRow {
  lead_id: string
  patient_name: string
  affiliator: { id: number; full_name: string } | null
  registered_at: string
  opened_at: string | null
  opened_by: { id: number; full_name: string } | null
}

export interface AffiliatorIntakeList {
  data: AffiliatorIntakeRow[]
  meta: { days: number; unopened: number }
}

export async function getAffiliatorIntakes(): Promise<AffiliatorIntakeList> {
  const response = await api.get<AffiliatorIntakeList>('/dashboard/affiliator-intakes')
  return response.data
}

/** First staff open wins on the server; later calls change nothing. */
export async function markAffiliatorIntakeOpened(leadId: string): Promise<void> {
  await api.post(`/leads/${leadId}/affiliator-intake/open`)
}
